import React, {PropsWithChildren} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATHS} from 'Routes';
import {device} from 'styled/device';
import {useFetchLockConditions, usePath, useScreenResize} from 'hooks';
import Page from 'components/Page';

type InternalRemoteAccessProps = PropsWithChildren & {
  subtitle?: string;
  isLoading?: boolean;
  title?: string;
};
function InternalRemoteAccess({
  subtitle,
  children,
  isLoading,
  title,
}: InternalRemoteAccessProps) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {isMatch} = useScreenResize(device.tablet);
  const {getFullPath} = usePath();
  const {data: locksConditions} = useFetchLockConditions();

  const goToHome = () => {
    navigate(getFullPath(PATHS.home));
  };

  if (locksConditions && !locksConditions?.is_show_keys_enabled) {
    return <Navigate to={`../`} />;
  }

  return (
    <Page
      isSubHeaderVisible
      title={title || t('my_keys')}
      isLoading={isLoading}
      navBarTitle={isMatch ? t('my_keys') : t('virtual_keys')}
      subtitle={subtitle}
      hideSubPanelBackButton
      onBackButtonClick={goToHome}
      className="remote-access-view"
    >
      {children}
    </Page>
  );
}

export default InternalRemoteAccess;
